module.exports = __webpack_public_path__ + "static/media/hand_sanitizer.c2df9d5b.svg";